import { Reveal } from "./Reveal";
import PillButton from "./PillButton";
import { WHATSAPP } from "../data/content";

// Elegant transition band between the hero photo and the Manifest section.
export default function HeroActions() {
    return (
        <div
            data-testid="hero-actions"
            className="flex flex-col items-center justify-center gap-4 px-6 pb-20 pt-16 sm:flex-row md:pb-24 md:pt-20"
        >
            <Reveal y={18}>
                <PillButton
                    href={WHATSAPP}
                    external
                    variant="solid"
                    testId="hero-book-btn"
                >
                    Programează-te
                </PillButton>
            </Reveal>
            <Reveal y={18} delay={0.08}>
                <PillButton
                    to="#portofoliu"
                    variant="outline"
                    testId="hero-portfolio-btn"
                >
                    Vezi portofoliul
                </PillButton>
            </Reveal>
        </div>
    );
}
